(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[233],{

/***/ 20359:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help",
      function () {
        return __webpack_require__(16507);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 27449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var useMediaQuery = function(width) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), targetReached = ref[0], setTargetReached = ref[1];
    var updateTarget = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        if (e.matches) {
            setTargetReached(true);
        } else {
            setTargetReached(false);
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var media = window.matchMedia("(max-width: ".concat(width, "px)"));
        media.addEventListener("change", updateTarget);
        if (media.matches) {
            setTargetReached(true);
        }
        return function() {
            return media.removeEventListener("change", updateTarget);
        };
    }, [
        updateTarget,
        width
    ]);
    return targetReached;
};
/* harmony default export */ __webpack_exports__["Z"] = (useMediaQuery);


/***/ }),

/***/ 16507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ help; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
// EXTERNAL MODULE: ../../brand/components/index.ts + 96 modules
var components = __webpack_require__(18381);
// EXTERNAL MODULE: ../../brand/theme/theme.ts + 18 modules
var theme = __webpack_require__(84516);
// EXTERNAL MODULE: ../../node_modules/@chakra-ui/icons/dist/chakra-ui-icons.esm.js
var chakra_ui_icons_esm = __webpack_require__(39680);
// EXTERNAL MODULE: ../../node_modules/@chakra-ui/accordion/dist/chakra-ui-accordion.esm.js
var chakra_ui_accordion_esm = __webpack_require__(3913);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@prismicio/react/dist/PrismicProvider.js
var PrismicProvider = __webpack_require__(71922);
;// CONCATENATED MODULE: ../../node_modules/@prismicio/react/dist/usePrismicContext.js


const usePrismicContext = () => {
  return react.useContext(PrismicProvider/* PrismicContext */.Z) || {};
};

//# sourceMappingURL=usePrismicContext.js.map

;// CONCATENATED MODULE: ../../node_modules/@prismicio/react/dist/usePrismicClient.js

const usePrismicClient = (explicitClient) => {
  const context = usePrismicContext();
  const client = explicitClient || (context == null ? void 0 : context.client);
  if (!client) {
    throw new Error("A @prismicio/client is required to query documents. Provide a client to the hook or to a <PrismicProvider> higher in your component tree.");
  }
  return client;
};

//# sourceMappingURL=usePrismicClient.js.map

;// CONCATENATED MODULE: ../../node_modules/@prismicio/react/dist/useStatefulPrismicClientMethod.js


const reducer = (state, action) => {
  switch (action[0]) {
    case "start": {
      return { state: "loading" };
    }
    case "succeed": {
      return { state: "loaded", data: action[1] };
    }
    case "fail": {
      return {
        ...state,
        state: "failed",
        error: action[1]
      };
    }
  }
};
const initialState = {
  state: "idle"
};
const isParams = (value) => {
  return typeof value === "object" && value !== null && !Array.isArray(value);
};
const useStatefulPrismicClientMethod_useStatefulPrismicClientMethod = (methodName, args, explicitClient) => {
  const lastArg = args[args.length - 1];
  const { client: lastArgExplicitClient, skip, ...params } = isParams(lastArg) ? lastArg : {};
  const argsWithoutParams = isParams(lastArg) ? args.slice(0, -1) : args;
  const client = usePrismicClient(explicitClient || lastArgExplicitClient);
  const [state, dispatch] = react.useReducer(reducer, initialState);
  react.useEffect(
    () => {
      if (!skip) {
        {
          dispatch(["start"]);
        }
        client[methodName].call(
          client,
          ...argsWithoutParams,
          params
        ).then((result) => {
          {
            dispatch(["succeed", result]);
          }
        }).catch((error) => {
          {
            dispatch(["fail", error]);
          }
        });
      }
    },
    // We must disable exhaustive-deps since we are using
    // JSON.stringify on params (effectively a deep equality check).
    // We want this effect to run again anytime params change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      client,
      methodName,
      skip,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(argsWithoutParams),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(params)
    ]
  );
  return react.useMemo(() => [
    state.data,
    {
      state: state.state,
      error: state.error
    }
  ], [state]);
};

//# sourceMappingURL=useStatefulPrismicClientMethod.js.map

;// CONCATENATED MODULE: ../../node_modules/@prismicio/react/dist/clientHooks.js

const usePrismicDocuments = (...args) => useStatefulPrismicClientMethod("get", args);
const useFirstPrismicDocument = (...args) => useStatefulPrismicClientMethod("getFirst", args);
const useAllPrismicDocumentsDangerously = (...args) => useStatefulPrismicClientMethod("dangerouslyGetAll", args);
const usePrismicDocumentByID = (...args) => useStatefulPrismicClientMethod("getByID", args);
const usePrismicDocumentsByIDs = (...args) => useStatefulPrismicClientMethod("getByIDs", args);
const useAllPrismicDocumentsByIDs = (...args) => useStatefulPrismicClientMethod("getAllByIDs", args);
const usePrismicDocumentByUID = (...args) => useStatefulPrismicClientMethod("getByUID", args);
const usePrismicDocumentsByUIDs = (...args) => useStatefulPrismicClientMethod("getByUIDs", args);
const useAllPrismicDocumentsByUIDs = (...args) => useStatefulPrismicClientMethod("getAllByUIDs", args);
const useSinglePrismicDocument = (...args) => useStatefulPrismicClientMethod_useStatefulPrismicClientMethod("getSingle", args);
const usePrismicDocumentsByType = (...args) => useStatefulPrismicClientMethod("getByType", args);
const useAllPrismicDocumentsByType = (...args) => useStatefulPrismicClientMethod("getAllByType", args);
const usePrismicDocumentsByTag = (...args) => useStatefulPrismicClientMethod("getByTag", args);
const useAllPrismicDocumentsByTag = (...args) => useStatefulPrismicClientMethod("getAllByTag", args);
const usePrismicDocumentsBySomeTags = (...args) => useStatefulPrismicClientMethod("getBySomeTags", args);
const useAllPrismicDocumentsBySomeTags = (...args) => useStatefulPrismicClientMethod("getAllBySomeTags", args);
const usePrismicDocumentsByEveryTag = (...args) => useStatefulPrismicClientMethod("getByEveryTag", args);
const useAllPrismicDocumentsByEveryTag = (...args) => useStatefulPrismicClientMethod("getAllByEveryTag", args);

//# sourceMappingURL=clientHooks.js.map

// EXTERNAL MODULE: ../../node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(18978);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../node_modules/@prismicio/richtext/dist/composeSerializers.js
const composeSerializers = (...serializers) => {
  return (...args) => {
    for (let i = 0; i < serializers.length; i++) {
      const serializer = serializers[i];
      if (serializer) {
        const res = serializer(...args);
        if (res != null) {
          return res;
        }
      }
    }
  };
};

//# sourceMappingURL=composeSerializers.js.map

;// CONCATENATED MODULE: ../../node_modules/@prismicio/types/dist/value/richText.js
const RichTextNodeType = {
  heading1: "heading1",
  heading2: "heading2",
  heading3: "heading3",
  heading4: "heading4",
  heading5: "heading5",
  heading6: "heading6",
  paragraph: "paragraph",
  preformatted: "preformatted",
  strong: "strong",
  em: "em",
  listItem: "list-item",
  oListItem: "o-list-item",
  list: "group-list-item",
  oList: "group-o-list-item",
  image: "image",
  embed: "embed",
  hyperlink: "hyperlink",
  label: "label",
  span: "span"
};

//# sourceMappingURL=richText.js.map

;// CONCATENATED MODULE: ../../node_modules/@prismicio/richtext/dist/types.js

const RichTextReversedNodeType = {
  [RichTextNodeType.listItem]: "listItem",
  [RichTextNodeType.oListItem]: "oListItem",
  [RichTextNodeType.list]: "list",
  [RichTextNodeType.oList]: "oList"
};

//# sourceMappingURL=types.js.map

;// CONCATENATED MODULE: ../../node_modules/@prismicio/richtext/dist/wrapMapSerializer.js

const wrapMapSerializer = (mapSerializer) => {
  return (type, node, text, children, key) => {
    const tagSerializer = mapSerializer[RichTextReversedNodeType[type] || type];
    if (tagSerializer) {
      return tagSerializer({
        // @ts-expect-error cannot type check here
        type,
        // @ts-expect-error cannot type check here
        node,
        // @ts-expect-error cannot type check here
        text,
        // @ts-expect-error cannot type check here
        children,
        // @ts-expect-error cannot type check here
        key
      });
    }
  };
};

//# sourceMappingURL=wrapMapSerializer.js.map

;// CONCATENATED MODULE: ../../node_modules/@prismicio/richtext/dist/asTree.js

const uuid = () => {
  return (++uuid.i).toString();
};
uuid.i = 0;
const asTree = (nodes) => {
  const preparedNodes = prepareNodes(nodes);
  const children = [];
  for (let i = 0; i < preparedNodes.length; i++) {
    children.push(nodeToTreeNode(preparedNodes[i]));
  }
  return {
    key: uuid(),
    children
  };
};
const createTreeNode = (node, children = []) => {
  return {
    key: uuid(),
    type: node.type,
    text: "text" in node ? node.text : void 0,
    node,
    children
  };
};
const createTextTreeNode = (text) => {
  return createTreeNode({
    type: RichTextNodeType.span,
    text,
    spans: []
  });
};
const prepareNodes = (nodes) => {
  const mutNodes = nodes.slice(0);
  for (let i = 0; i < mutNodes.length; i++) {
    const node = mutNodes[i];
    if (node.type === RichTextNodeType.listItem || node.type === RichTextNodeType.oListItem) {
      const items = [
        node
      ];
      while (mutNodes[i + 1] && mutNodes[i + 1].type === node.type) {
        items.push(mutNodes[i + 1]);
        mutNodes.splice(i, 1);
      }
      if (node.type === RichTextNodeType.listItem) {
        mutNodes[i] = {
          type: RichTextNodeType.list,
          items
        };
      } else {
        mutNodes[i] = {
          type: RichTextNodeType.oList,
          items
        };
      }
    }
  }
  return mutNodes;
};
const nodeToTreeNode = (node) => {
  if ("text" in node) {
    return createTreeNode(node, textNodeSpansToTreeNodeChildren(node.spans, node));
  }
  if ("items" in node) {
    const children = [];
    for (let i = 0; i < node.items.length; i++) {
      children.push(nodeToTreeNode(node.items[i]));
    }
    return createTreeNode(node, children);
  }
  return createTreeNode(node);
};
const textNodeSpansToTreeNodeChildren = (spans, node, parentSpan) => {
  if (!spans.length) {
    return [createTextTreeNode(node.text)];
  }
  const mutSpans = spans.slice(0);
  mutSpans.sort((a, b) => a.start - b.start || b.end - a.end);
  const children = [];
  for (let i = 0; i < mutSpans.length; i++) {
    const span = mutSpans[i];
    const parentSpanStart = parentSpan && parentSpan.start || 0;
    const spanStart = span.start - parentSpanStart;
    const spanEnd = span.end - parentSpanStart;
    const text = node.text.slice(spanStart, spanEnd);
    const childSpans = [];
    for (let j = i; j < mutSpans.length; j++) {
      const siblingSpan = mutSpans[j];
      if (siblingSpan !== span) {
        if (siblingSpan.start >= span.start && siblingSpan.end <= span.end) {
          childSpans.push(siblingSpan);
          mutSpans.splice(j, 1);
          j--;
        } else if (siblingSpan.start < span.end && siblingSpan.end > span.start) {
          childSpans.push({
            ...siblingSpan,
            end: span.end
          });
          mutSpans[j] = {
            ...siblingSpan,
            start: span.end
          };
        }
      }
    }
    if (i === 0 && spanStart > 0) {
      children.push(createTextTreeNode(node.text.slice(0, spanStart)));
    }
    const spanWithText = { ...span, text };
    children.push(createTreeNode(spanWithText, textNodeSpansToTreeNodeChildren(childSpans, {
      ...node,
      text
    }, span)));
    if (spanEnd < node.text.length) {
      children.push(createTextTreeNode(node.text.slice(spanEnd, mutSpans[i + 1] ? mutSpans[i + 1].start - parentSpanStart : void 0)));
    }
  }
  return children;
};

//# sourceMappingURL=asTree.js.map

;// CONCATENATED MODULE: ../../node_modules/@prismicio/richtext/dist/serialize.js

const serialize = (richTextField, serializer) => {
  return serializeTreeNodes(asTree(richTextField).children, serializer);
};
const serializeTreeNodes = (nodes, serializer) => {
  const serializedTreeNodes = [];
  for (let i = 0; i < nodes.length; i++) {
    const treeNode = nodes[i];
    const serializedTreeNode = serializer(treeNode.type, treeNode.node, treeNode.text, serializeTreeNodes(treeNode.children, serializer), treeNode.key);
    if (serializedTreeNode != null) {
      serializedTreeNodes.push(serializedTreeNode);
    }
  }
  return serializedTreeNodes;
};

//# sourceMappingURL=serialize.js.map

;// CONCATENATED MODULE: ../../node_modules/@prismicio/react/dist/_node_modules/@prismicio/client/dist/lib/isInternalURL.js
const isInternalURL = (url) => {
  const isInternal = /^(\/(?!\/)|#)/.test(url);
  const isSpecialLink = !isInternal && !/^https?:\/\//.test(url);
  return isInternal && !isSpecialLink;
};

//# sourceMappingURL=isInternalURL.js.map

;// CONCATENATED MODULE: ../../node_modules/@prismicio/react/dist/_node_modules/@prismicio/client/dist/types/value/link.js
const LinkType = {
  Any: "Any",
  Document: "Document",
  Media: "Media",
  Web: "Web"
};

//# sourceMappingURL=link.js.map

;// CONCATENATED MODULE: ../../node_modules/@prismicio/react/dist/_node_modules/@prismicio/client/dist/helpers/documentToLinkField.js

const documentToLinkField = (prismicDocument) => {
  var _a;
  return {
    link_type: LinkType.Document,
    id: prismicDocument.id,
    uid: prismicDocument.uid || void 0,
    type: prismicDocument.type,
    tags: prismicDocument.tags,
    lang: prismicDocument.lang,
    url: prismicDocument.url == null ? void 0 : prismicDocument.url,
    slug: (_a = prismicDocument.slugs) == null ? void 0 : _a[0],
    // The REST API does not include a `data` property if the data
    // object is empty.
    //
    // A presence check for `prismicDocument.data` is done to
    // support partial documents. While `documentToLinkField` is
    // not typed to accept partial documents, passing a partial
    // document can happen in untyped projects.
    ...prismicDocument.data && Object.keys(prismicDocument.data).length > 0 ? { data: prismicDocument.data } : {}
  };
};

//# sourceMappingURL=documentToLinkField.js.map

;// CONCATENATED MODULE: ../../node_modules/@prismicio/react/dist/_node_modules/@prismicio/client/dist/helpers/asLink.js


const asLink = (linkFieldOrDocument, ...configObjectOrTuple) => {
  if (!linkFieldOrDocument) {
    return null;
  }
  const linkField = (
    // prettier-ignore
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - Bug in TypeScript 4.9: https://github.com/microsoft/TypeScript/issues/51501
    // TODO: Remove the `prettier-ignore` comment when this bug is fixed.
    "link_type" in linkFieldOrDocument ? linkFieldOrDocument : documentToLinkField(linkFieldOrDocument)
  );
  const [configObjectOrLinkResolver] = configObjectOrTuple;
  let config;
  if (typeof configObjectOrLinkResolver === "function" || configObjectOrLinkResolver == null) {
    config = {
      linkResolver: configObjectOrLinkResolver
    };
  } else {
    config = { ...configObjectOrLinkResolver };
  }
  switch (linkField.link_type) {
    case LinkType.Media:
    case LinkType.Web:
      return "url" in linkField ? linkField.url : null;
    case LinkType.Document: {
      if ("id" in linkField && config.linkResolver) {
        const resolvedURL = config.linkResolver(linkField);
        if (resolvedURL != null) {
          return resolvedURL;
        }
      }
      if ("url" in linkField && linkField.url) {
        return linkField.url;
      }
      return null;
    }
    case LinkType.Any:
    default:
      return null;
  }
};

//# sourceMappingURL=asLink.js.map

;// CONCATENATED MODULE: ../../node_modules/@prismicio/react/dist/_node_modules/@prismicio/client/dist/helpers/isFilled.js
const isNonNullish = (input) => {
  return input != null;
};
const richText = (field) => {
  if (!isNonNullish(field)) {
    return false;
  } else if (field.length === 1 && "text" in field[0]) {
    return !!field[0].text;
  } else {
    return !!field.length;
  }
};
const imageThumbnail = (thumbnail) => {
  return isNonNullish(thumbnail) && !!thumbnail.url;
};
const isFilled_link = (field) => {
  return isNonNullish(field) && ("id" in field || "url" in field);
};

//# sourceMappingURL=isFilled.js.map

;// CONCATENATED MODULE: ../../node_modules/@prismicio/react/dist/_node_modules/@prismicio/client/dist/helpers/asLinkAttrs.js



const asLinkAttrs = (linkFieldOrDocument, config = {}) => {
  if (linkFieldOrDocument && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore - Bug in TypeScript 4.9: https://github.com/microsoft/TypeScript/issues/51501
  ("link_type" in linkFieldOrDocument ? isFilled_link(linkFieldOrDocument) : linkFieldOrDocument)) {
    const target = (
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore - Bug in TypeScript 4.9: https://github.com/microsoft/TypeScript/issues/51501
      "target" in linkFieldOrDocument ? linkFieldOrDocument.target : void 0
    );
    const rawHref = asLink(linkFieldOrDocument, config.linkResolver);
    const href = rawHref == null ? void 0 : rawHref;
    const isExternal = typeof href === "string" ? !isInternalURL(href) : false;
    const rel = config.rel ? config.rel({ href, isExternal, target }) : isExternal ? "noreferrer" : void 0;
    return {
      href,
      target,
      rel: rel == null ? void 0 : rel
    };
  }
  return {};
};

//# sourceMappingURL=asLinkAttrs.js.map

;// CONCATENATED MODULE: ../../node_modules/@prismicio/react/dist/lib/isInternalURL.js
const isInternalURL_isInternalURL = (url) => {
  const isInternal = /^(\/(?!\/)|#)/.test(url);
  const isSpecialLink = !isInternal && !/^https?:\/\//.test(url);
  return isInternal && !isSpecialLink;
};

//# sourceMappingURL=isInternalURL.js.map

;// CONCATENATED MODULE: ../../node_modules/@prismicio/react/dist/react-server/PrismicLink.js
/* provided dependency */ var process = __webpack_require__(34406);






const defaultComponent = "a";
const PrismicLink = react.forwardRef(function PrismicLink2({ field, document: doc, linkResolver, internalComponent, externalComponent, ...restProps }, ref) {
  if (typeof process !== "undefined" && "production" === "development") {}
  const { href: computedHref, rel: computedRel, ...attrs } = asLinkAttrs(field ?? doc, {
    linkResolver,
    rel: typeof restProps.rel === "function" ? restProps.rel : void 0
  });
  let rel = computedRel;
  if ("rel" in restProps && typeof restProps.rel !== "function") {
    rel = restProps.rel;
  }
  const href = ("href" in restProps ? restProps.href : computedHref) || "";
  const InternalComponent = internalComponent || defaultComponent;
  const ExternalComponent = externalComponent || defaultComponent;
  const Component = href && isInternalURL_isInternalURL(href) ? InternalComponent : ExternalComponent;
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(Component, { ref, ...attrs, ...restProps, href, rel });
});

//# sourceMappingURL=PrismicLink.js.map

;// CONCATENATED MODULE: ../../node_modules/@prismicio/react/dist/react-server/PrismicRichText.js
/* provided dependency */ var PrismicRichText_process = __webpack_require__(34406);






const createDefaultSerializer = (args) => wrapMapSerializer({
  heading1: ({ children, key }) => /* @__PURE__ */ (0,jsx_runtime.jsx)("h1", { children }, key),
  heading2: ({ children, key }) => /* @__PURE__ */ (0,jsx_runtime.jsx)("h2", { children }, key),
  heading3: ({ children, key }) => /* @__PURE__ */ (0,jsx_runtime.jsx)("h3", { children }, key),
  heading4: ({ children, key }) => /* @__PURE__ */ (0,jsx_runtime.jsx)("h4", { children }, key),
  heading5: ({ children, key }) => /* @__PURE__ */ (0,jsx_runtime.jsx)("h5", { children }, key),
  heading6: ({ children, key }) => /* @__PURE__ */ (0,jsx_runtime.jsx)("h6", { children }, key),
  paragraph: ({ children, key }) => /* @__PURE__ */ (0,jsx_runtime.jsx)("p", { children }, key),
  preformatted: ({ node, key }) => /* @__PURE__ */ (0,jsx_runtime.jsx)("pre", { children: node.text }, key),
  strong: ({ children, key }) => /* @__PURE__ */ (0,jsx_runtime.jsx)("strong", { children }, key),
  em: ({ children, key }) => /* @__PURE__ */ (0,jsx_runtime.jsx)("em", { children }, key),
  listItem: ({ children, key }) => /* @__PURE__ */ (0,jsx_runtime.jsx)("li", { children }, key),
  oListItem: ({ children, key }) => /* @__PURE__ */ (0,jsx_runtime.jsx)("li", { children }, key),
  list: ({ children, key }) => /* @__PURE__ */ (0,jsx_runtime.jsx)("ul", { children }, key),
  oList: ({ children, key }) => /* @__PURE__ */ (0,jsx_runtime.jsx)("ol", { children }, key),
  image: ({ node, key }) => {
    const img = /* @__PURE__ */ (0,jsx_runtime.jsx)("img", { src: node.url, alt: node.alt ?? void 0, "data-copyright": node.copyright ? node.copyright : void 0 });
    return /* @__PURE__ */ (0,jsx_runtime.jsx)("p", { className: "block-img", children: node.linkTo ? /* @__PURE__ */ (0,jsx_runtime.jsx)(PrismicLink, { linkResolver: args.linkResolver, internalComponent: args.internalLinkComponent, externalComponent: args.externalLinkComponent, field: node.linkTo, children: img }) : img }, key);
  },
  embed: ({ node, key }) => /* @__PURE__ */ (0,jsx_runtime.jsx)("div", { "data-oembed": node.oembed.embed_url, "data-oembed-type": node.oembed.type, "data-oembed-provider": node.oembed.provider_name, dangerouslySetInnerHTML: { __html: node.oembed.html ?? "" } }, key),
  hyperlink: ({ node, children, key }) => /* @__PURE__ */ (0,jsx_runtime.jsx)(PrismicLink, { field: node.data, linkResolver: args.linkResolver, internalComponent: args.internalLinkComponent, externalComponent: args.externalLinkComponent, children }, key),
  label: ({ node, children, key }) => /* @__PURE__ */ (0,jsx_runtime.jsx)("span", { className: node.data.label, children }, key),
  span: ({ text, key }) => {
    const result = [];
    let i = 0;
    for (const line of text.split("\n")) {
      if (i > 0) {
        result.push(/* @__PURE__ */ (0,jsx_runtime.jsx)("br", {}, `${i}__break`));
      }
      result.push(/* @__PURE__ */ (0,jsx_runtime.jsx)(react.Fragment, { children: line }, `${i}__line`));
      i++;
    }
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(react.Fragment, { children: result }, key);
  }
});
function PrismicRichText({ linkResolver, field, fallback, components, externalLinkComponent, internalLinkComponent, ...restProps }) {
  return react.useMemo(() => {
    if (typeof PrismicRichText_process !== "undefined" && "production" === "development") {}
    if (richText(field)) {
      const serializer = composeSerializers(typeof components === "object" ? wrapMapSerializer(components) : components, createDefaultSerializer({
        linkResolver,
        internalLinkComponent,
        externalLinkComponent
      }));
      const serialized = serialize(field, (type, node, text, children, key) => {
        const result = serializer(type, node, text, children, key);
        if (react.isValidElement(result) && result.key == null) {
          return react.cloneElement(result, { key });
        } else {
          return result;
        }
      });
      return /* @__PURE__ */ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children: serialized });
    } else {
      return fallback != null ? /* @__PURE__ */ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children: fallback }) : null;
    }
  }, [
    field,
    internalLinkComponent,
    externalLinkComponent,
    components,
    linkResolver,
    fallback
  ]);
}

//# sourceMappingURL=PrismicRichText.js.map

;// CONCATENATED MODULE: ../../node_modules/@prismicio/react/dist/PrismicRichText.js




const PrismicRichText_PrismicRichText = function PrismicRichText2({ components, ...restProps }) {
  const context = usePrismicContext();
  const serializer = composeSerializers(typeof components === "object" ? wrapMapSerializer(components) : components, typeof context.richTextComponents === "object" ? wrapMapSerializer(context.richTextComponents) : context.richTextComponents);
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(PrismicRichText, { components: serializer, internalLinkComponent: context.internalLinkComponent, externalLinkComponent: context.externalLinkComponent, ...restProps });
};

//# sourceMappingURL=PrismicRichText.js.map

;// CONCATENATED MODULE: ./src/components/atoms/PrismicRichText/PrismicRichText.tsx





var PrismicRichText_PrismicRichText_PrismicRichText = function(props) {
    var _color = props.color, color = _color === void 0 ? theme/* theme.colors.secondary */.r.colors.secondary : _color; // Assign a default color if not provided
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PrismicRichText_PrismicRichText, {
        field: props.render,
        components: {
            heading1: function(param) {
                var children = param.children;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Heading */.X6, {
                    variant: "h1",
                    mb: 2,
                    color: color,
                    children: children
                });
            },
            heading2: function(param) {
                var children = param.children;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Heading */.X6, {
                    variant: "h2",
                    color: color,
                    children: children
                });
            },
            heading3: function(param) {
                var children = param.children;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Heading */.X6, {
                    variant: "h3",
                    mb: 2,
                    color: color,
                    children: children
                });
            },
            heading4: function(param) {
                var children = param.children;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Heading */.X6, {
                    variant: "h4",
                    mb: 2,
                    color: color,
                    children: children
                });
            },
            heading5: function(param) {
                var children = param.children;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Heading */.X6, {
                    variant: "h5",
                    mb: 2,
                    color: color,
                    children: children
                });
            },
            heading6: function(param) {
                var children = param.children;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Heading */.X6, {
                    variant: "h6",
                    mb: 2,
                    color: color,
                    children: children
                });
            },
            paragraph: function(param) {
                var children = param.children;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Text */.xv, {
                    mb: 8,
                    color: color,
                    textAlign: "justify",
                    children: children
                });
            },
            strong: function(param) {
                var children = param.children;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                    style: {
                        color: color
                    },
                    children: children
                });
            },
            em: function(param) {
                var children = param.children;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("em", {
                    style: {
                        color: color
                    },
                    children: children
                });
            },
            list: function(param) {
                var children = param.children;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* List */.aV, {
                    spacing: 4,
                    mb: 4,
                    color: color,
                    children: children
                });
            },
            listItem: function(param) {
                var children = param.children;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components/* ListItem */.HC, {
                    gap: 4,
                    color: color,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            style: {
                                marginRight: "5px"
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* FaCheckCircle */.FJM, {
                                color: color
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            children: children
                        })
                    ]
                });
            },
            oList: function(param) {
                var children = param.children;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* OrderedList */.GS, {
                    color: color,
                    children: children
                });
            },
            oListItem: function(param) {
                var children = param.children;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components/* ListItem */.HC, {
                    fontWeight: "medium",
                    display: "list-item",
                    color: color,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            style: {
                                marginRight: "5px"
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* FaCheckCircle */.FJM, {
                                color: color
                            })
                        }),
                        children
                    ]
                });
            },
            hyperlink: function(param) {
                var node = param.node, children = param.children;
                if (node.data.link_type === "Web") {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Link */.rU, {
                        href: node.data.url,
                        target: node.data.target,
                        color: "primary.base",
                        children: children
                    });
                } else {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Link */.rU, {
                        href: node.data.url,
                        // target={node.data.target}
                        color: "primary.base",
                        children: children
                    });
                }
            }
        }
    });
};

;// CONCATENATED MODULE: ./src/components/atoms/PrismicRichText/index.ts


// EXTERNAL MODULE: ./src/components/organisms/layouts/Base/index.tsx + 12 modules
var Base = __webpack_require__(22563);
// EXTERNAL MODULE: ./src/components/utils/IsVisible/index.tsx
var IsVisible = __webpack_require__(92238);
;// CONCATENATED MODULE: ./src/helpers/prismicImgixLoader.ts
var prismicImgixLoader = function(props) {
    return "".concat(props.src, "&w=").concat(props.width, "&q=").concat(props.quality);
};

// EXTERNAL MODULE: ./src/hooks/useMediaQuery/index.tsx
var useMediaQuery = __webpack_require__(27449);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(76699);
// EXTERNAL MODULE: ../../node_modules/uuid/dist/esm-browser/v4.js + 4 modules
var v4 = __webpack_require__(6804);
// EXTERNAL MODULE: ./src/pages/help/styles.module.css
var styles_module = __webpack_require__(46760);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/pages/help/index.tsx

















var HelpPage = function() {
    var ref = (0,useTranslation/* useTranslation */.$)("common"), t = ref.t, i18n = ref.i18n;
    var locale = (0,react.useMemo)(function() {
        return i18n.language;
    }, [
        i18n.language
    ]);
    var dimension = (0,useMediaQuery/* default */.Z)(768);
    var ref1 = (0,react.useState)(), selectedGroupOfQuestions = ref1[0], setSelectedGroupOfQuestions = ref1[1];
    var ref2 = (0,react.useState)([]), faqGroups = ref2[0], setFaqGroups = ref2[1];
    var ref3 = (0,react.useState)(), preFooterSlice = ref3[0], setPreFooterSlice = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)(useSinglePrismicDocument("help_page", {
        lang: locale === "fr" ? "fr-be" : "nl-be"
    }), 1), prismicData = ref4[0];
    (0,react.useEffect)(function() {
        var ref, ref1;
        var prismicSlices = prismicData === null || prismicData === void 0 ? void 0 : (ref = prismicData.data) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.map(function(slice) {
            if (slice.slice_type === "help_section_group_faq") {
                var questions = slice.items.map(function(question) {
                    return question;
                });
                return {
                    sectionTitle: slice.primary.section_title,
                    questions: questions,
                    sliceType: slice.slice_type
                };
            } else if (slice.slice_type === "prefooter") {
                return {
                    preFooterTitle: slice.primary.prefooter_title,
                    preFooterSubTitle: slice.primary.prefooter_subtitle,
                    sliceType: slice.slice_type
                };
            }
            return slice;
        });
        if (!prismicSlices) return;
        setFaqGroups(prismicSlices.filter(function(slice) {
            return slice.sliceType === "help_section_group_faq";
        }));
        setPreFooterSlice(prismicSlices.find(function(slice) {
            return slice.sliceType === "prefooter";
        }));
    }, [
        prismicData
    ]);
    var handleOpenGroupOfQuestions = function(section) {
        setSelectedGroupOfQuestions(section);
    };
    var handleBackIcon = function() {
        setSelectedGroupOfQuestions(null);
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    var renderQuestionGroups = function() {
        if (!faqGroups) return;
        var formattedSlices = faqGroups.map(function(questionsGroup, index) {
            var SectionTitle = questionsGroup.sectionTitle;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Flex */.kC, {
                alignItems: "center",
                justifyContent: "center",
                p: "1rem",
                borderRadius: "0.5rem",
                transition: "0.5s transform ease",
                margin: !dimension ? "4rem" : "1rem",
                padding: !dimension ? "70px 100px 100px 100px" : "30px 10px 30px 10px",
                width: !dimension ? "400px" : "300px",
                height: !dimension ? "300px" : "150px",
                className: index % 2 === 0 ? (styles_module_default()).questionGroupPair : (styles_module_default()).questionGroupOdd,
                onClick: function() {
                    return handleOpenGroupOfQuestions(SectionTitle);
                },
                _hover: {
                    background: theme/* theme.colors.primary.base */.r.colors.primary.base,
                    cursor: "pointer",
                    transform: "translateY(-10px)"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Heading */.X6, {
                    fontFamily: theme/* theme.fonts.heading */.r.fonts.heading,
                    variant: "h4",
                    style: {
                        color: "white",
                        textAlign: "center"
                    },
                    children: SectionTitle
                })
            }, (0,v4/* default */.Z)());
        });
        return formattedSlices;
    };
    var renderQuestionGroup = function() {
        if (!faqGroups || faqGroups.length === 0) {
            return null;
        }
        var formattedQuestions = faqGroups.map(function(questionsGroup, index) {
            var SectionTitle = questionsGroup.sectionTitle;
            if (SectionTitle === selectedGroupOfQuestions) {
                var ref;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components/* Flex */.kC, {
                    padding: !dimension ? "70px 100px 100px 100px" : "30px 10px 30px 10px",
                    width: !dimension ? "80vw" : "90vw",
                    borderRadius: "0.5rem",
                    className: index % 2 === 0 ? (styles_module_default()).questionGroupPair : (styles_module_default()).questionGroupOdd,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Heading */.X6, {
                            fontFamily: theme/* theme.fonts.heading */.r.fonts.heading,
                            variant: "h4",
                            style: {
                                color: "white"
                            },
                            children: SectionTitle
                        }),
                        (ref = questionsGroup.questions) === null || ref === void 0 ? void 0 : ref.map(function(question) {
                            var ref;
                            /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Box */.xu, {
                                width: "100%",
                                m: "20px",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Accordion */.UQ, {
                                    width: "100%",
                                    allowToggle: true,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components/* AccordionItem */.Qd, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* AccordionButton */.KF, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Box */.xu, {
                                                    flex: "1",
                                                    textAlign: "left",
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Heading */.X6, {
                                                        variant: "h6",
                                                        children: question.question_title
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_accordion_esm/* AccordionPanel */.Hk, {
                                                px: [
                                                    "20px",
                                                    "40px",
                                                    "40px"
                                                ],
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PrismicRichText_PrismicRichText_PrismicRichText, {
                                                        render: question.question_content
                                                    }),
                                                    ((ref = question.question_image) === null || ref === void 0 ? void 0 : ref.url) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Flex */.kC, {
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                                            src: question.question_image.url,
                                                            alt: question.question_image.alt || "missing alt description",
                                                            layout: "fixed",
                                                            width: "250px",
                                                            height: "250px",
                                                            loader: prismicImgixLoader
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }, question.question_title);
                        })
                    ]
                }, "".concat(SectionTitle, "-").concat(index));
            }
            return null;
        });
        return formattedQuestions;
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Base/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Heading */.X6, {
                textAlign: "center",
                children: t("generic.help")
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components/* Flex */.kC, {
                "flex-wrap": "wrap",
                padding: "1rem 1.2rem",
                justifyContent: "center",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IsVisible/* default */.Z, {
                        when: !!selectedGroupOfQuestions,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components/* Flex */.kC, {
                            direction: "column",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Flex */.kC, {
                                    w: "100px",
                                    h: "100px",
                                    p: "1rem",
                                    m: "auto",
                                    border: "2.4px solid #405a6b",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderRadius: "100%",
                                    cursor: "pointer",
                                    onClick: function() {
                                        return handleBackIcon();
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_icons_esm/* ArrowBackIcon */.Rp, {
                                        style: {
                                            height: "50px",
                                            width: "100px"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Flex */.kC, {
                                    flexWrap: "wrap",
                                    alignItems: "center",
                                    m: !dimension ? "4rem" : "0rem",
                                    justifyContent: "center",
                                    children: faqGroups && renderQuestionGroup()
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Flex */.kC, {
                                    w: "100px",
                                    h: "100px",
                                    p: "1rem",
                                    m: "auto",
                                    border: "2.4px solid #405a6b",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderRadius: "100%",
                                    cursor: "pointer",
                                    onClick: function() {
                                        return handleBackIcon();
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_icons_esm/* ArrowBackIcon */.Rp, {
                                        style: {
                                            height: "50px",
                                            width: "100px"
                                        }
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IsVisible/* default */.Z, {
                        when: !selectedGroupOfQuestions,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Flex */.kC, {
                            flexWrap: "wrap",
                            alignItems: "center",
                            justifyContent: "center",
                            children: faqGroups && renderQuestionGroups()
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IsVisible/* default */.Z, {
                when: !!preFooterSlice,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components/* Flex */.kC, {
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    padding: "30px",
                    borderRadius: "0.5rem",
                    margin: "0 auto",
                    mb: 4,
                    w: "80vw",
                    backgroundColor: theme/* theme.colors.secondary */.r.colors.secondary,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PrismicRichText_PrismicRichText_PrismicRichText, {
                            color: "white",
                            render: preFooterSlice && (preFooterSlice === null || preFooterSlice === void 0 ? void 0 : preFooterSlice.preFooterTitle)
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PrismicRichText_PrismicRichText_PrismicRichText, {
                            color: "white",
                            render: preFooterSlice && (preFooterSlice === null || preFooterSlice === void 0 ? void 0 : preFooterSlice.preFooterSubTitle)
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var help = (HelpPage);


/***/ }),

/***/ 46760:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"questionGroupPair":"styles_questionGroupPair__Mq6L9","gradient":"styles_gradient__rZ5U9","questionGroupOdd":"styles_questionGroupOdd__YoHre","gradientOdd":"styles_gradientOdd__Qyj_Y"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [525,912,577,563,774,888,179], function() { return __webpack_exec__(20359); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);